import { Component, input, model } from '@angular/core';
import { UwIcon } from '../icon/uw-icon';

@Component({
  selector: 'uw-search',
  standalone: true,
  imports: [UwIcon],
  template: `
    <div class="relative">
      <uw-icon name="search" class="pointer-events-none absolute left-2.5 top-1/2 -translate-y-1/2 text-text-muted" [size]="14" />
      <input
        #input
        [value]="query()"
        (input)="query.set(input.value)"
        [placeholder]="placeholder()"
        [attr.aria-label]="placeholder()"
        class="w-full rounded-lg border border-line bg-surface pl-8 pr-8 text-[12.5px] text-primary placeholder:text-text-muted transition-colors focus:border-ai focus:outline-none focus:ring-2 focus:ring-ai/20"
        [class]="size() === 'sm' ? 'py-1.5' : 'py-2'"
      />
      @if (query()) {
        <button
          class="absolute right-2 top-1/2 -translate-y-1/2 rounded text-text-muted transition-colors hover:text-primary"
          (click)="query.set('')"
          [attr.aria-label]="'Clear search'"
        >
          <uw-icon name="x" [size]="13" />
        </button>
      }
    </div>
  `,
})
export class UwSearch {
  readonly query = model('');
  readonly placeholder = input('Search…');
  readonly size = input<'sm' | 'md'>('md');
}
